import { CoinMark } from "@/components/brand/Logo";
import { cn } from "@/lib/utils";

export const EmptyState = ({ icon: Icon, title, text, action, compact = false, testid = "empty-state" }) => (
  <div className={cn("flex flex-col items-center justify-center text-center", compact ? "gap-2 py-6" : "gap-3 py-14")} data-testid={testid}>
    <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-secondary">
      {Icon ? <Icon className="h-5 w-5 text-sage" strokeWidth={1.8} /> : <CoinMark size={28} />}
    </div>
    <div className="font-heading text-sm font-semibold">{title}</div>
    {text && <p className="max-w-xs text-xs leading-relaxed text-muted-foreground">{text}</p>}
    {action}
  </div>
);
